import React from 'react'
import * as R from 'ramda'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import styles from './DropdownMenu.module.scss'

export const DropdownMenu = ({
  onClick,
  filter = {},
  filtersConfig,
  className = undefined,
}) => {
  const ref = React.useRef(null)

  const handleToggle = (toggleValue, key) =>
    onClick({ ...filter, [key]: toggleValue(filter[key]) })

  return (
    <Dropdown.Menu
      className={cx(styles.menu, { [className]: Boolean(className) })}
    >
      <Box direction="column" className={styles.filters}>
        {R.map(
          ({ key, label, toggleValue }) => (
            <div className={styles.container} key={key}>
              <Checkbox
                value={filter[key]}
                fieldClassName={styles.checkbox}
                onChange={e => handleToggle(toggleValue, key)}
                ref={ref}
                key={label}
              />
              <div
                className={styles.label}
                onClick={() => handleToggle(toggleValue, key)}
              >
                {label}
              </div>
            </div>
          ),
          filtersConfig,
        )}
      </Box>
    </Dropdown.Menu>
  )
}
